<template>
    <div>
        <div v-if="!showToggle">
            <button class="btn btn-info" @click="toggleRegSelect">Go Back To Registration Rates</button>
            <br><br>
        </div>
        <div class="reg-select" style="background-color: #b7b7b71c; padding: 15px; border-radius: 5px"
             v-if="showToggle">

            <div class="table-responsive" v-for="cat in state.meetingData.reg_type_cat">
                <h3>{{cat}}</h3>
                <table class="table table-condensed">
                    <thead>
                    <tr>
                        <th style="text-align: left" scope="col">Registration Type</th>
                        <th scope="col">Price</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="reg in state.meetingData.reg_type" v-if="reg.name === cat">
                        <td style="text-align: left" scope="row">{{reg.type}} <span v-if="reg.details"><br>({{reg.details}})</span>
                        </td>
                        <td>${{reg.regularPrice}}</td>
                        <td><input @change="setShow" name="regSelect" type="radio"
                                   @click="updateRegType(reg)"></td>

                    </tr>
                    </tbody>
                </table>
            </div>

        </div>

    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import GuestTickets from './GuestTickets'

    export default {
        name: 'RegSelect',
        data: function () {
            return {
                formstate: {},
                showToggle: true
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
        },
        methods: {
            toggleRegSelect() {
                this.showToggle = !this.showToggle;
            },
            updateRegType(reg) {
              this.$store.commit('updateRegType', reg);
              this.$store.commit('removePromoVal');
            },
            setShow() {
                this.showToggle = !this.showToggle;
                if (this.state.registrantData.regType) {
                    this.state.showSection = {
                        medical: false,
                        trainee: false,
                        oneDay: false,
                        industry: false,
                    };

                    const groupsRequired = this.state.registrantData.regType.extraFieldGroupsRequired;
                    groupsRequired.filter((group) => {
                        this.state.showSection[group] = true;
                    });
                }
                this.$store.commit('updateTotal')
            },
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },

        },
        components: {
            GuestTickets,
        }
    }
</script>

<style scoped>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
</style>
